import { useMemo } from 'react'

import type { SessionRecord } from '../types'
import { SessionDataTree } from './SessionDataTree'

/** Metadata not already promoted into the session header. */
export function SessionMetadata({
  metadata,
  excludedKeys,
}: {
  metadata: SessionRecord['metadata']
  excludedKeys: readonly string[]
}) {
  const entries = useMemo(
    () =>
      metadata && typeof metadata === 'object' && !Array.isArray(metadata)
        ? Object.entries(metadata).filter(
            ([name]) => !excludedKeys.includes(name)
          )
        : [],
    [excludedKeys, metadata]
  )
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) {
    return null
  }
  if (entries.length === 0) return null

  return (
    <details data-session-metadata className="pt-1">
      <summary className="cursor-pointer select-none text-xs text-gray-500 hover:text-gray-700">
        Show additional metadata{' '}
        <span className="text-gray-400">({entries.length})</span>
      </summary>
      <div className="mt-2 ml-4">
        <SessionDataTree entries={entries} />
      </div>
    </details>
  )
}
